"use client";
export const handleBillingPortalRedirect = async () => {
  try {
    const response = await fetch("/api/stripe/billing", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const result = await response.json();

    if (result.error) {
      console.error("Error creating customer billing session:", result.message);
      return;
    }
    // If the response is a redirect, follow it
    const redirectUrl = result.data;
    window.location.href = redirectUrl;
  } catch (err) {
    console.error("Error during POST request:", err);
    // setError("Failed to redirect to the billing portal");
  } finally {
    // setLoading(false);
  }
};
